import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
import { CTASection } from '../components/sections/CTASection';
import { Layers, Code2, Palette, TrendingUp, ArrowRight } from 'lucide-react';
export function ServicesPage() {
  const services = [{
    icon: <Layers className="w-8 h-8" data-id="element-393" />,
    title: 'Digital Product Design',
    description: 'We design intuitive, visually refined interfaces and experiences that enhance usability and engagement.',
    features: ['User Experience (UX) Design', 'User Interface (UI) Design', 'Design Systems & Component Libraries', 'Prototyping & User Testing', 'Mobile & Responsive Design']
  }, {
    icon: <Code2 className="w-8 h-8" data-id="element-394" />,
    title: 'Web & App Development',
    description: 'We build fast, modern, scalable digital platforms tailored to performance and reliability.',
    features: ['Custom Web Applications', 'Mobile App Development', 'E-commerce Solutions', 'API Development & Integration', 'Performance Optimization']
  }, {
    icon: <Palette className="w-8 h-8" data-id="element-395" />,
    title: 'Brand & Visual Identity',
    description: 'We craft cohesive brand systems, visual identities, and design assets that communicate clearly and confidently.',
    features: ['Logo Design & Brand Marks', 'Brand Guidelines & Systems', 'Visual Identity Development', 'Marketing Collateral', 'Iconography & Illustration']
  }, {
    icon: <TrendingUp className="w-8 h-8" data-id="element-396" />,
    title: 'Digital Growth & Strategy',
    description: 'We support digital visibility, optimization, and performance through structured growth strategies.',
    features: ['Digital Strategy & Consulting', 'SEO & Content Strategy', 'Analytics & Performance Tracking', 'Conversion Optimization', 'Marketing Campaign Support']
  }];
  return <main className="pt-24" data-id="element-397">
      {/* Hero */}
      <Section background="default" data-id="element-398">
        <div className="max-w-4xl" data-id="element-399">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-[#0C0C0C] mb-6 leading-tight" data-id="element-400">
            Our Services
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 leading-relaxed" data-id="element-401">
            We design and build digital solutions that align with your business
            goals, user needs, and long-term growth strategy.
          </motion.p>
        </div>
      </Section>

      {/* Services List */}
      <Section background="white" data-id="element-402">
        <div className="space-y-24" data-id="element-403">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-404">
              <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-405">
                <div className="w-16 h-16 bg-[#F8F8F6] rounded-xl flex items-center justify-center text-[#00316B] mb-6" data-id="element-406">
                  {service.icon}
                </div>
                <h2 className="text-3xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-407">
                  {service.title}
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-408">
                  {service.description}
                </p>
                <ul className="space-y-3" data-id="element-409">
                  {service.features.map(feature => <li key={feature} className="flex items-center text-gray-700" data-id="element-410">
                      <ArrowRight className="w-4 h-4 text-[#00316B] mr-3 shrink-0" data-id="element-411" />
                      {feature}
                    </li>)}
                </ul>
              </div>

              <div className={`relative h-[350px] bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-412">
                {/* Abstract visual placeholder */}
                <div className="absolute inset-0 flex items-center justify-center opacity-20" data-id="element-413">
                  {service.icon}
                </div>
              </div>
            </motion.div>)}
        </div>
      </Section>

      <CTASection data-id="element-414" />
    </main>;
}